module.exports = __webpack_public_path__ + "img/translationeditor_8.bf28c63a.jpg";